<template>
  <component :is="currentComponent" />
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.cjs.js";
import Home from "../pages/Home.vue";
import NavigationPage from "../pages/NavigationPage.vue";

export default {
  name: "ResponsiveHome",
  components: {
    Home,
    NavigationPage,
  },
  data() {
    return {
      currentComponent: "Home",
    };
  },
  watch: {
    isShowDesktopHome() {
      this.checkDeviceType();
    },
  },
  methods: {
    checkDeviceType() {
      if (this.isDekstop || this.isLaptop || this.isShowDesktopHome) {
        this.currentComponent = "Home";
      } else {
        this.currentComponent = "Home";
      }
    },
  },
  mounted() {
    this.checkDeviceType();
    window.addEventListener("resize", this.checkDeviceType);
  },
  unmounted() {
    window.removeEventListener("resize", this.checkDeviceType);
  },
  computed: {
    ...mapGetters({
      isDekstop: "isDesktop",
      isLaptop :"isLaptop",
      isShowDesktopHome: "isShowDesktopHome",
    }),
  },
};
</script>
